export const BASE_URL_V2 = import.meta.env.VITE_BASE_URL_V2 as string;
export const BASE_URL_LEGACY = import.meta.env.VITE_BASE_URL_LEGACY as string;
export const BASE_URL_BILLING_SERVICE = import.meta.env.VITE_BASE_URL_BILLING_SERVICE as string;
export const BASE_URL_BFF_SERVICE = import.meta.env.VITE_BASE_URL_BFF_FEATURE_BRANCH as string;

// Sandbox-only override so RET-XXX local testing can route sandbox uploads to
// local storage-management-service while the rest of the FE keeps hitting
// staging (other in-flight E2E flows depend on staging via .env.local).
// Falls back to BASE_URL_LEGACY when unset — production behavior is unchanged.
export const BASE_URL_STORAGE_SANDBOX =
  (import.meta.env.VITE_BASE_URL_STORAGE_SANDBOX as string) || BASE_URL_LEGACY;

// HTTP Status Codes
export const STATUS_OK = 200;
export const STATUS_ACCEPTED = 202;
export const STATUS_BAD_REQUEST = 400;
export const STATUS_UNAUTHORIZED = 401;
export const STATUS_FORBIDDEN = 403;
export const STATUS_NOT_FOUND = 404;
export const STATUS_CONFLICT = 409;
export const STATUS_GONE = 410;
export const STATUS_UNPROCESSABLE_CONTENT = 422;
export const STATUS_FAILED_DEPENDENCY = 424;
export const STATUS_UPGRADE_REQUIRED = 426;
export const STATUS_PRECONDITION_REQUIRED = 428;
export const STATUS_TOO_MANY_REQUESTS = 429;
